export default {
  qInfo: { qType: 'table' },
  qHyperCubeDef: {
    qStateName: '',
    qDimensions: [
      // {
      //   qDef: {
      //     qFieldDefs: [
      //       '[Sort Order]',
      //     ],
      //     qSortCriterias: [
      //       {
      //         qSortByState: 0,
      //         qSortByAscii: 1,
      //       },
      //     ],
      //   },
      // },
      {
        qLibraryId: '',
        qDef: {
          qGrouping: 'N',
          qFieldDefs: [
            '=Text(SKU)',
          ],
          qFieldLabels: [
            'SKU',
          ],
          qSortCriterias: [
            {
              qSortByState: 0,
              qSortByFrequency: 0,
              qSortByNumeric: 0,
              qSortByAscii: 0,
              qSortByLoadOrder: 1,
              qSortByExpression: 0,
              qExpression: {
                qv: '',
              },
              qSortByGreyness: 0,
            },
          ],
          qNumberPresentations: [],
          qReverseSort: false,
          qActiveField: 0,
          qLabelExpression: '',
          autoSort: false,
          // cId: 'YNppXA',
          othersLabel: 'Others',
          textAlign: {
            auto: true,
            align: 'left',
          },
          representation: {
            type: 'text',
            urlLabel: '',
          },
        },
        qNullSuppression: false,
        qIncludeElemValue: false,
        qOtherTotalSpec: {
          qOtherMode: 'OTHER_OFF',
          qOtherCounted: {
            qv: '10',
          },
          qOtherLimit: {
            qv: '0',
          },
          qOtherLimitMode: 'OTHER_GE_LIMIT',
          qSuppressOther: false,
          qForceBadValueKeeping: true,
          qApplyEvenWhenPossiblyWrongResult: true,
          qGlobalOtherGrouping: false,
          qOtherCollapseInnerDimensions: false,
          qOtherSortMode: 'OTHER_SORT_DESCENDING',
          qTotalMode: 'TOTAL_OFF',
          qReferencedExpression: {
            qv: '',
          },
        },
        qShowTotal: false,
        qShowAll: false,
        qOtherLabel: {
          qv: 'Others',
        },
        qTotalLabel: {
          qv: '',
        },
        qCalcCond: {
          qv: '',
        },
        qAttributeExpressions: [],
        qAttributeDimensions: [],
        qCalcCondition: {
          qCond: {
            qv: '',
          },
          qMsg: {
            qv: '',
          },
        },
      },
      {
        qLibraryId: '',
        qDef: {
          qGrouping: 'N',
          qFieldDefs: [
            'Matrix Description',
          ],
          qFieldLabels: [
            '',
          ],
          qSortCriterias: [
            {
              qSortByState: 0,
              qSortByFrequency: 0,
              qSortByNumeric: 0,
              qSortByAscii: 0,
              qSortByLoadOrder: 1,
              // qSortByExpression: 0,
              // qExpression: {
              //   qv: '[License Type Sort Order]',
              // },
              qSortByGreyness: 0,
            },
          ],
          qNumberPresentations: [],
          qReverseSort: false,
          qActiveField: 0,
          qLabelExpression: '',
          autoSort: false,
          // cId: 'Zjdmx',
          othersLabel: 'Others',
          textAlign: {
            auto: true,
            align: 'left',
          },
          representation: {
            type: 'text',
            urlLabel: '',
          },
        },
        qNullSuppression: true,
        qIncludeElemValue: false,
        qOtherTotalSpec: {
          qOtherMode: 'OTHER_OFF',
          qOtherCounted: {
            qv: '10',
          },
          qOtherLimit: {
            qv: '0',
          },
          qOtherLimitMode: 'OTHER_GE_LIMIT',
          qSuppressOther: false,
          qForceBadValueKeeping: true,
          qApplyEvenWhenPossiblyWrongResult: true,
          qGlobalOtherGrouping: false,
          qOtherCollapseInnerDimensions: false,
          qOtherSortMode: 'OTHER_SORT_DESCENDING',
          qTotalMode: 'TOTAL_OFF',
          qReferencedExpression: {
            qv: '',
          },
        },
        qShowTotal: false,
        qShowAll: false,
        qOtherLabel: {
          qv: 'Others',
        },
        qTotalLabel: {
          qv: '',
        },
        qCalcCond: {
          qv: '',
        },
        qAttributeExpressions: [],
        qAttributeDimensions: [],
        qCalcCondition: {
          qCond: {
            qv: '',
          },
          qMsg: {
            qv: '',
          },
        },
      },
      {
        qLibraryId: '',
        qDef: {
          qGrouping: 'N',
          qFieldDefs: [
            'Matrix Unit',
          ],
          qFieldLabels: [
            '',
          ],
          qSortCriterias: [
            {
              qSortByState: 0,
              qSortByFrequency: 0,
              qSortByNumeric: 0,
              qSortByAscii: 0,
              qSortByLoadOrder: 1,
              // qSortByExpression: 0,
              // qExpression: {
              //   qv: '',
              // },
              qSortByGreyness: 0,
            },
          ],
          qNumberPresentations: [],
          qReverseSort: false,
          qActiveField: 0,
          qLabelExpression: '',
          autoSort: false,
          // cId: 'ZJsJbP',
          othersLabel: 'Others',
          textAlign: {
            auto: true,
            align: 'left',
          },
          representation: {
            type: 'text',
            urlLabel: '',
          },
        },
        qNullSuppression: true,
        qIncludeElemValue: false,
        qOtherTotalSpec: {
          qOtherMode: 'OTHER_OFF',
          qOtherCounted: {
            qv: '10',
          },
          qOtherLimit: {
            qv: '0',
          },
          qOtherLimitMode: 'OTHER_GE_LIMIT',
          qSuppressOther: false,
          qForceBadValueKeeping: true,
          qApplyEvenWhenPossiblyWrongResult: true,
          qGlobalOtherGrouping: false,
          qOtherCollapseInnerDimensions: false,
          qOtherSortMode: 'OTHER_SORT_DESCENDING',
          qTotalMode: 'TOTAL_OFF',
          qReferencedExpression: {
            qv: '',
          },
        },
        qShowTotal: false,
        qShowAll: false,
        qOtherLabel: {
          qv: 'Others',
        },
        qTotalLabel: {
          qv: '',
        },
        qCalcCond: {
          qv: '',
        },
        qAttributeExpressions: [],
        qAttributeDimensions: [],
        qCalcCondition: {
          qCond: {
            qv: '',
          },
          qMsg: {
            qv: '',
          },
        },
      },
      {
        qLibraryId: '',
        qDef: {
          qGrouping: 'N',
          qFieldDefs: [
            'Matrix Comments',
          ],
          qFieldLabels: [
            '',
          ],
          qSortCriterias: [
            {
              qSortByState: 0,
              qSortByFrequency: 0,
              qSortByNumeric: 0,
              qSortByAscii: 0,
              qSortByLoadOrder: 1,
              // qSortByExpression: 0,
              // qExpression: {
              //   qv: '[License Type Sort Order]',
              // },
              qSortByGreyness: 0,
            },
          ],
          qNumberPresentations: [],
          qReverseSort: false,
          qActiveField: 0,
          qLabelExpression: '',
          autoSort: false,
          // cId: 'Zjdmx',
          othersLabel: 'Others',
          textAlign: {
            auto: true,
            align: 'left',
          },
          representation: {
            type: 'text',
            urlLabel: '',
          },
        },
        qNullSuppression: false,
        qIncludeElemValue: false,
        qOtherTotalSpec: {
          qOtherMode: 'OTHER_OFF',
          qOtherCounted: {
            qv: '10',
          },
          qOtherLimit: {
            qv: '0',
          },
          qOtherLimitMode: 'OTHER_GE_LIMIT',
          qSuppressOther: false,
          qForceBadValueKeeping: true,
          qApplyEvenWhenPossiblyWrongResult: true,
          qGlobalOtherGrouping: false,
          qOtherCollapseInnerDimensions: false,
          qOtherSortMode: 'OTHER_SORT_DESCENDING',
          qTotalMode: 'TOTAL_OFF',
          qReferencedExpression: {
            qv: '',
          },
        },
        qShowTotal: false,
        qShowAll: false,
        qOtherLabel: {
          qv: 'Others',
        },
        qTotalLabel: {
          qv: '',
        },
        qCalcCond: {
          qv: '',
        },
        qAttributeExpressions: [],
        qAttributeDimensions: [],
        qCalcCondition: {
          qCond: {
            qv: '',
          },
          qMsg: {
            qv: '',
          },
        },
      },
      {
        qLibraryId: '',
        qDef: {
          qGrouping: 'N',
          qFieldDefs: [
            'Z-Index',
          ],
          qFieldLabels: [
            '',
          ],
          qSortCriterias: [
            {
              qSortByState: 0,
              qSortByFrequency: 0,
              qSortByNumeric: 0,
              qSortByAscii: 0,
              qSortByLoadOrder: 1,
              // qSortByExpression: 0,
              // qExpression: {
              //   qv: '[License Type Sort Order]',
              // },
              qSortByGreyness: 0,
            },
          ],
          qNumberPresentations: [],
          qReverseSort: false,
          qActiveField: 0,
          qLabelExpression: '',
          autoSort: false,
          // cId: 'Zjdmx',
          othersLabel: 'Others',
          textAlign: {
            auto: true,
            align: 'left',
          },
          representation: {
            type: 'text',
            urlLabel: '',
          },
        },
        qNullSuppression: false,
        qIncludeElemValue: false,
        qOtherTotalSpec: {
          qOtherMode: 'OTHER_OFF',
          qOtherCounted: {
            qv: '10',
          },
          qOtherLimit: {
            qv: '0',
          },
          qOtherLimitMode: 'OTHER_GE_LIMIT',
          qSuppressOther: false,
          qForceBadValueKeeping: true,
          qApplyEvenWhenPossiblyWrongResult: true,
          qGlobalOtherGrouping: false,
          qOtherCollapseInnerDimensions: false,
          qOtherSortMode: 'OTHER_SORT_DESCENDING',
          qTotalMode: 'TOTAL_OFF',
          qReferencedExpression: {
            qv: '',
          },
        },
        qShowTotal: false,
        qShowAll: false,
        qOtherLabel: {
          qv: 'Others',
        },
        qTotalLabel: {
          qv: '',
        },
        qCalcCond: {
          qv: '',
        },
        qAttributeExpressions: [],
        qAttributeDimensions: [],
        qCalcCondition: {
          qCond: {
            qv: '',
          },
          qMsg: {
            qv: '',
          },
        },
      },
    ],
    qMeasures: [
      {
        qLibraryId: '',
        qDef: {
          qLabel: '',
          qDescription: '',
          qTags: [],
          qGrouping: 'N',
          // qDef: 'Sum(Value)',
          qDef: 'Sum({<[Price Guide Include]={\'Yes\'}>} Value)',
          // qDef: 'Sum({<[Matrix Price List Include]={\'Yes\'}>} Value)',
          // qDef: 'Sum({<[Webapp Include]={\'Yes\'}>}  Value)',
          qNumFormat: {
            qType: 'U',
            qnDec: 10,
            qUseThou: 0,
            qFmt: '',
            qDec: '',
            qThou: '',
          },
          qRelative: false,
          qBrutalSum: false,
          qAggrFunc: 'Expr',
          qAccumulate: 0,
          qReverseSort: false,
          qActiveExpression: 0,
          qExpressions: [],
          qLabelExpression: '=GetFieldSelections(Currency)',
          autoSort: false,
          // cId: 'mFKJPH',
          numFormatFromTemplate: true,
          textAlign: {
            auto: true,
            align: 'left',
          },
        },
        qSortBy: {
          qSortByState: 0,
          qSortByFrequency: 0,
          qSortByNumeric: 0,
          qSortByAscii: 0,
          qSortByLoadOrder: 1,
          qSortByExpression: 0,
          qExpression: {
            qv: '',
          },
          qSortByGreyness: 0,
        },
        qAttributeExpressions: [],
        qAttributeDimensions: [],
        qCalcCond: {
          qv: '',
        },
        qCalcCondition: {
          qCond: {
            qv: '',
          },
          qMsg: {
            qv: '',
          },
        },
      },
    ],
    //   qInterColumnSortOrder: [
    //     0,
    //     1,
    //     2,
    //     3,
    //     4,
    //     5,
    //     6,
    //     7,
    //   ],
    qSuppressZero: false,
    qSuppressMissing: true,
    qInitialDataFetch: [{
      qLeft: 0,
      qWidth: 6,
      qHeight: 1600,
    }],
    qReductionMode: 'N',
    qMode: 'S',
  },
  currency: { qStringExpression: { qExpr: 'only(Currency)' } },
  date: { qStringExpression: { qExpr: 'only([Month Year])' } },
};

